import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highchartsPatternFill from 'highcharts-pattern-fill';
import { TopMarketComponent } from "../TopMarketComponent/TopMarketComponent";
import { InvestmentDTO } from "../../model/investmentDTO";
import { TooltipComponent } from "../../utils/TooltipComponent/TooltipComponent";
import { usePageWidth } from "../ResultsContainer/UsePageWidthHook";

highchartsPatternFill(Highcharts);
interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any;
  chart1data: InvestmentDTO;
}

export const HighChartWrapper = (props: Props) => {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chartRef = useRef<any>(null);
  useEffect(() => {
    if (props.options.chartTooltips) {
      props.options.chartTooltips.map((tooltip: { title: string; url: string; elementId: string }) => {
        if (document.getElementById(tooltip.elementId)) {
          ReactDOM.render(<TooltipComponent title={tooltip.title} url={tooltip.url} key={tooltip.elementId} screenreaderText={`More info on ${tooltip.title}`} />, document.getElementById(tooltip.elementId));
        }
      });
    }
  }, [props.options]);

  const { pageWidth } = usePageWidth();
  const graphLegendBackgroundMinPageWidth = 100; // TODO: fix this for small screens as fast follow.
  
  useEffect(() => {
    if (chartRef.current !== null) {
      const chart = chartRef.current.chart;
      const hcPlotbackground = document.getElementsByClassName('highcharts-plot-background')[0].getBBox();
      const hcBackground = document.getElementsByClassName('highcharts-background')[0].getBBox();
      const x = hcPlotbackground.x;
      const width = hcPlotbackground.width;
      const y = hcPlotbackground.y + hcPlotbackground.height;
      let height = hcBackground.height - hcPlotbackground.height;
      const bgColor = '#f2f7fa';
      if (pageWidth < graphLegendBackgroundMinPageWidth) {
        chart.legend.options.align = "center";
        chart.legend.options.verticalAlign = "bottom";
        chart.legend.options.layout = "horizontal";
        chart.legend.options.y = 30;
        height += 50;
        chart.isDirtyLegend = true;
      } else {
        chart.legend.options.align = "right";
        chart.legend.options.verticalAlign = "bottom";
        chart.legend.options.layout = "vertical";
        chart.legend.options.y = -10;
        chart.isDirtyLegend = true;
      }
      if(chart.newChartRect){
        chart.newChartRect.destroy();
      }
      chart.newChartRect = chart.renderer.rect(x, y, width, height).attr({
          fill: bgColor,
          zIndex: 3,
          class: 'flexguard-chart-dynamic-background'
        }).add();
      
    }
  }, [chartRef, pageWidth])


  return (
    <div>
      <TopMarketComponent data={props.chart1data} />

      <div className="row">
        <div className="col-sm-12">
          <HighchartsReact highcharts={Highcharts} options={props.options} ref={chartRef} />
        </div>
      </div>

    </div>
  );
};
